<template>
  <div id="app">
    <div class="container">
        <TheNav />

        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
        <footer>
          <div>
            <p>Encuéntrame en </p>
            <a
            target="_blank"
            href="https://www.linkedin.com/in/nicole-loupias/"
            ><font-awesome-icon :icon="['fab', 'linkedin']" size="lg" /></a
            >
            <a
              target="_blank"
              href="https://github.com/nicoleloupias"
              ><font-awesome-icon :icon="['fab', 'github']" size="lg" /></a
            >
            <a
              target="_blank"
              href="https://twitter.com/NicoleCoding"
              ><font-awesome-icon :icon="['fab', 'twitter']" size="lg" /></a
            >
          </div>

        <div>
          <p> Hecho con ❤️️ por Nicole Loupias <span>©</span> 2020</p>
        </div>

        </footer>
    </div>
  </div>
</template>
<script>
import TheNav from "./components/TheNav";
export default {
  components: {
    TheNav
  }
}
</script>
<style lang="scss" src="./global.scss">
</style>
